import React from 'react';
import '../../../../mobilestyle.css';

const LeaderboardItem = ({ data, colorMapping, isHighlighted }) => {
  const inGroup = (data.inGroup || '').trim();
  const badgeColor = colorMapping[inGroup];
  const isOut = data.rowNumber === 'OUT';

  return (
    <div
      className={`v2-card${isHighlighted && !isOut ? ' row-highlight' : ''}`}
      style={isOut ? { background: '#f5f5f5', opacity: 0.7 } : undefined}
    >
      {/* Col 1: position + start number badge */}
      <div className="v2-left">
        <div className="v2-pos">{data.rowNumber}</div>
        <div className="v2-num">#{data.positionNumber}</div>
      </div>

      {/* Col 2: driver / co-driver / class + car */}
      <div className="v2-middle">
        <div className="v2-d1">{(data.driverName || '').trim()}</div>
        <div className="v2-d2">{(data.coDriverName || '').trim()}</div>
        <div className="v2-car-row">
          {inGroup && (
            data.classPosition != null && data.classPosition !== 'OUT' ? (
              <span className="v2-split-badge" style={{ borderColor: badgeColor || '#ccc' }}>
                <span className="v2-split-badge-label" style={{ background: badgeColor || '#71717a' }}>{inGroup}</span>
                <span className="v2-split-badge-pos">#{data.classPosition}</span>
              </span>
            ) : (
              <span className="v2-class-badge" style={{ background: badgeColor || '#71717a' }}>{inGroup}</span>
            )
          )}
          <span className="v2-car">{(data.car || '').trim()}</span>
        </div>
      </div>

      {/* Col 3: time + gaps + speed */}
      <div className="v2-right">
        <div className="v2-time">{data.resultTime}</div>
        {data.penalty && (
          <div className="penalty">
            <div className="penalty-text">+{data.penalty}</div>
          </div>
        )}
        {data.taryfa && (
          <div className="taryfa">
            <div className="taryfa-text">Taryfa</div>
          </div>
        )}
        <div className="v2-gaps">
          <span><span className="v2-gap-label">L </span>{data.diffToFirst}</span>
          <span><span className="v2-gap-label">P </span>{data.diffToPrev}</span>
        </div>
        {data.avgSpeedKmh != null && (
          <div className="v2-speed">
            {data.avgSpeedKmh} km/h
            {data.speedDeficitKmh != null && data.speedDeficitKmh > 0 && (
              <span className="v2-speed-delta"> −{data.speedDeficitKmh}</span>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

// Jawny komparator: obiekty wierszy są przebudowywane przy każdym przeliczeniu
// silnika, więc porównujemy renderowane pola zamiast referencji.
// Lista pól musi odpowiadać kształtowi wierszy z engineCalculator.js.
const ROW_FIELDS = [
  'rowNumber', 'positionNumber', 'driverName', 'coDriverName', 'car', 'inGroup',
  'classPosition', 'resultTime', 'penalty', 'taryfa', 'diffToFirst', 'diffToPrev',
  'avgSpeedKmh', 'speedDeficitKmh',
];

const areEqual = (prevProps, nextProps) =>
  prevProps.isHighlighted === nextProps.isHighlighted &&
  prevProps.colorMapping === nextProps.colorMapping &&
  ROW_FIELDS.every((f) => prevProps.data[f] === nextProps.data[f]);

export default React.memo(LeaderboardItem, areEqual);
